// Geteilte Bausteine des Risiken-/Analysen-Bereichs: die Inline-SVG-Icons und
// der Normalisierungs-Helper für den Abgleich von riskType-Freitext.
//
// Herausgelöst aus ContactRisksPanel, damit der Analyse-Knopf (AnalyseButton)
// dieselben Icons nutzt, statt sie zu duplizieren — er wird an zwei Stellen
// gerendert: im Risiken-Reiter und im Reiter „Analyse“.

import * as React from "react";

export const ic = (children: JSX.Element) => (
  <svg
    viewBox="0 0 36 36"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: "100%", height: "100%", display: "block" }}
  >
    {children}
  </svg>
);

export const Icons = {
  clipboard: () =>
    ic(
      <>
        <rect x="9" y="6" width="18" height="24" rx="2" />
        <rect x="13" y="3" width="10" height="5" rx="1" />
        <line x1="13" y1="14" x2="23" y2="14" />
        <line x1="13" y1="19" x2="23" y2="19" />
        <line x1="13" y1="24" x2="20" y2="24" />
      </>
    ),
  magnifier: () =>
    ic(
      <>
        <circle cx="16" cy="16" r="9" />
        <line x1="22" y1="22" x2="30" y2="30" />
      </>
    ),
  microscope: () =>
    ic(
      <>
        <path d="M14 4l8 8" />
        <path d="M12 6l-3 3 9 9 3-3z" />
        <line x1="17" y1="22" x2="13" y2="26" />
        <line x1="12" y1="28" x2="22" y2="28" />
        <path d="M22 16a8 8 0 0 1 6 12" />
      </>
    ),
  factory: () =>
    ic(
      <>
        <path d="M5 30V16l7 4v-4l7 4V12l9 6v12z" />
        <line x1="11" y1="26" x2="11" y2="28" />
        <line x1="18" y1="26" x2="18" y2="28" />
        <line x1="25" y1="26" x2="25" y2="28" />
      </>
    ),
  house: () =>
    ic(
      <>
        <path d="M5 18l13-11 13 11" />
        <path d="M8 16v14h20V16" />
        <rect x="15" y="20" width="6" height="10" />
      </>
    ),
  car: () =>
    ic(
      <>
        <path d="M6 22l3-8a3 3 0 0 1 2.8-2h12.4a3 3 0 0 1 2.8 2l3 8" />
        <path d="M4 22h28v6H4z" />
        <circle cx="11" cy="26" r="2" />
        <circle cx="25" cy="26" r="2" />
      </>
    ),
  shield: () =>
    ic(
      <>
        <path d="M18 4l11 4v8c0 7-5 13-11 16-6-3-11-9-11-16V8z" />
        <path d="M13 18l4 4 7-8" />
      </>
    ),
  shieldExclaim: () =>
    ic(
      <>
        <path d="M18 4l11 4v8c0 7-5 13-11 16-6-3-11-9-11-16V8z" />
        <line x1="18" y1="12" x2="18" y2="20" />
        <circle cx="18" cy="24" r="0.6" />
      </>
    ),
  tree: () =>
    ic(
      <>
        <path d="M18 4l7 9h-4l5 7h-4l4 6H10l4-6h-4l5-7H11z" />
        <line x1="18" y1="26" x2="18" y2="32" />
        <line x1="14" y1="32" x2="22" y2="32" />
      </>
    ),
  truck: () =>
    ic(
      <>
        <rect x="3" y="11" width="17" height="13" />
        <path d="M20 14h7l5 5v5H20z" />
        <circle cx="10" cy="27" r="2.5" />
        <circle cx="26" cy="27" r="2.5" />
      </>
    ),
  people: () =>
    ic(
      <>
        <circle cx="13" cy="13" r="4" />
        <circle cx="24" cy="14" r="3" />
        <path d="M5 28c0-4 3.5-7 8-7s8 3 8 7" />
        <path d="M21 28c0-3 2.5-5 5.5-5s5.5 2 5.5 5" />
      </>
    ),
  euro: () =>
    ic(
      <>
        <circle cx="18" cy="18" r="13" />
        <path d="M25 11a9 9 0 1 0 0 14" />
        <line x1="9" y1="16" x2="22" y2="16" />
        <line x1="9" y1="20" x2="22" y2="20" />
      </>
    ),
  cyber: () =>
    ic(
      <>
        <rect x="6" y="10" width="24" height="14" rx="2" />
        <line x1="12" y1="28" x2="24" y2="28" />
        <line x1="10" y1="14" x2="14" y2="14" />
        <line x1="10" y1="18" x2="20" y2="18" />
      </>
    ),
  chart: () =>
    ic(
      <>
        <line x1="5" y1="30" x2="31" y2="30" />
        <rect x="8" y="20" width="4" height="10" />
        <rect x="16" y="14" width="4" height="16" />
        <rect x="24" y="9" width="4" height="21" />
      </>
    ),
  gear: () =>
    ic(
      <>
        <circle cx="18" cy="18" r="4" />
        <path d="M18 4v4M18 28v4M4 18h4M28 18h4M8 8l3 3M25 25l3 3M8 28l3-3M25 11l3-3" />
      </>
    ),
  bulldozer: () =>
    ic(
      <>
        <path d="M4 24l4-8h10l4 4v4" />
        <rect x="2" y="24" width="22" height="4" />
        <circle cx="8" cy="29" r="2" />
        <circle cx="20" cy="29" r="2" />
        <line x1="24" y1="14" x2="32" y2="14" />
        <line x1="24" y1="14" x2="24" y2="22" />
      </>
    ),
  oilTank: () =>
    ic(
      <>
        <rect x="6" y="10" width="20" height="18" rx="3" />
        <line x1="6" y1="16" x2="26" y2="16" />
        <line x1="16" y1="10" x2="16" y2="28" />
        <path d="M26 14l4-4v18" />
      </>
    ),
  briefcase: () =>
    ic(
      <>
        <rect x="5" y="11" width="26" height="18" rx="2" />
        <path d="M13 11V8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v3" />
        <line x1="5" y1="20" x2="31" y2="20" />
      </>
    ),
  box: () =>
    ic(
      <>
        <path d="M5 11l13-6 13 6v14l-13 6-13-6z" />
        <line x1="5" y1="11" x2="18" y2="17" />
        <line x1="31" y1="11" x2="18" y2="17" />
        <line x1="18" y1="17" x2="18" y2="31" />
      </>
    ),
  branchActivity: () =>
    ic(
      <>
        <circle cx="9" cy="9" r="3" />
        <circle cx="27" cy="9" r="3" />
        <circle cx="18" cy="27" r="3" />
        <line x1="9" y1="12" x2="18" y2="24" />
        <line x1="27" y1="12" x2="18" y2="24" />
        <line x1="9" y1="9" x2="27" y2="9" />
      </>
    ),
  lossChart: () =>
    ic(
      <>
        <line x1="5" y1="30" x2="31" y2="30" />
        <polyline points="5,12 12,18 18,14 24,22 31,16" />
      </>
    ),
  list: () =>
    ic(
      <>
        <line x1="6" y1="9" x2="30" y2="9" />
        <line x1="6" y1="18" x2="30" y2="18" />
        <line x1="6" y1="27" x2="30" y2="27" />
        <circle cx="3" cy="9" r="0.5" />
        <circle cx="3" cy="18" r="0.5" />
        <circle cx="3" cy="27" r="0.5" />
      </>
    ),
  inbox: () =>
    ic(
      <>
        <path d="M5 6h26l-3 14H8z" />
        <path d="M5 20v10h26V20" />
        <path d="M13 24h10" />
      </>
    ),
  clock: () =>
    ic(
      <>
        <circle cx="18" cy="18" r="12" />
        <polyline points="18,11 18,18 24,21" />
      </>
    ),
  check: () =>
    ic(
      <>
        <circle cx="18" cy="18" r="13" />
        <polyline points="11,18 16,23 25,13" />
      </>
    ),
  checkSimple: () =>
    ic(
      <>
        <polyline points="8,18 15,25 28,11" />
      </>
    ),
  dash: () =>
    ic(
      <>
        <line x1="10" y1="18" x2="26" y2="18" />
      </>
    ),
  arrow: () =>
    ic(
      <>
        <line x1="8" y1="18" x2="28" y2="18" />
        <polyline points="22,12 28,18 22,24" />
      </>
    ),
  chevronRight: () =>
    ic(
      <>
        <polyline points="14,9 23,18 14,27" />
      </>
    ),
  close: () =>
    ic(
      <>
        <line x1="9" y1="9" x2="27" y2="27" />
        <line x1="27" y1="9" x2="9" y2="27" />
      </>
    ),
  plus: () =>
    ic(
      <>
        <line x1="18" y1="8" x2="18" y2="28" />
        <line x1="8" y1="18" x2="28" y2="18" />
      </>
    ),
  sparkle: () =>
    ic(
      <>
        <path d="M18 4l3 9 9 3-9 3-3 9-3-9-9-3 9-3z" />
      </>
    ),
  sun: () =>
    ic(
      <>
        <circle cx="18" cy="18" r="6" />
        <line x1="18" y1="4" x2="18" y2="9" />
        <line x1="18" y1="27" x2="18" y2="32" />
        <line x1="4" y1="18" x2="9" y2="18" />
        <line x1="27" y1="18" x2="32" y2="18" />
        <line x1="8" y1="8" x2="11.5" y2="11.5" />
        <line x1="24.5" y1="24.5" x2="28" y2="28" />
        <line x1="8" y1="28" x2="11.5" y2="24.5" />
        <line x1="24.5" y1="11.5" x2="28" y2="8" />
      </>
    ),
};

export type IconFn = () => JSX.Element;

/** riskType-Freitext für den Kachel-Abgleich normalisieren. */
export const norm = (s: string | undefined) => (s ?? "").toLowerCase();
